import { useQuery } from "@tanstack/react-query";
import { portfolioApi } from "../api/portfolio";

export const useFetchPortfolioDetails = ({ portfolioId }: { portfolioId: string | undefined }) => {

    const { data, isPending, isRefetching, isSuccess, isError, error } = useQuery({
        queryKey: ["portfolio-details", portfolioId],
        queryFn: () => portfolioApi.getPortfolioDetails({ portfolioId }),
        enabled: !!portfolioId,
    });

    return {
        data: isSuccess ? data.data : [],
        isLoading: isPending,
        isError,
        error,
    };

};